import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from '../../services/app-config.service';

@Pipe({
    name: 'orgCurrencySymbol',
    pure: false // Impure to allow updates if config loads late, though usually config loads first.
})
export class OrgCurrencySymbolPipe implements PipeTransform {
    constructor(private configService: AppConfigService) {}

    transform(value: any): string {
        try {
             return this.configService.get('currencySymbol') || '₪';
        } catch (e) {
            return '₪';
        }
    }
}
